import React from 'react';
import Navbar from './components/navbar/navbar';

import "./impress.css";
import "./pages/pages.css";

const Impress = () => {
    return (
        <div>
            <Navbar />

            <div className="section background" >
                <div className="viewport">
                    <div>
                        <h1>Impressum</h1>

                        <h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
                        <p>Nadezda L&ouml;we<br />
                            Naturheilpraxis Nadja L&ouml;we<br />
                            Ziegetsdorfer Str. 32<br />
                            93051 Regensburg</p>

                        <h2>Kontakt</h2>
                        <p>Telefon: +49177 6962490<br />
                            E-Mail: admin@hp-loewe.com</p>

                        <h2>Aufsichtsbeh&ouml;rde</h2>
                        <p>Gesundheitsamt / Landratsamt Regensburg<br />
                           Altmühlstraße 3<br />
                           93059 Regensburg</p>

                        <h2>Berufsbezeichnung und berufsrechtliche Regelungen</h2>
                        <p>Berufsbezeichnung:<br />
                            Heilpraktiker</p>
                        <p>Zust&auml;ndige Kammer:<br />
                            Gesundheitsamt / Landratsamt Landshut<br />
                        </p>
                        <p>Verliehen in:<br />
                            Landshut, Deutschland</p>
                        <p>Es gelten folgende berufsrechtliche Regelungen:</p>
                        <h2>Angaben zur Berufs&shy;haftpflicht&shy;versicherung</h2>
                        <h2>Redaktionell verantwortlich</h2>
                        <p>Nadezda L&ouml;we<br />
                            Naturheilpraxis Nadja L&ouml;we<br />
                            Ziegetsdorfer Str. 32<br />
                            93051 Regensburg</p>
                        <p>Quelle: <a href="https://www.e-recht24.de">https://www.e-recht24.de</a></p>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default Impress;